import { decodeToken } from "../../Utility/DecodeJwt";
import { toasterModel, toasterColor } from "../../Models/ToasterModel";
import router from "../../router";
import {
  tokensConstant,
  getLocalStorageItem,
  setLocalStorageItem
} from "../../Utility/LocalStorage";

export const userSchema = (
  id = "",
  userName = "",
  role = "",
  area = "",
  team = "",
  office = "",
  profileUrl = "",
  group = "",
  email = ""
) => {
  return {
    id: id,
    userName: userName,
    role: role,
    area: area,
    team: team,
    office: office,
    profileUrl: profileUrl,
    group: group,
    email: email
  };
};

let initialState = {
  user: userSchema(),
  loaderState: false,

  snackbar: {
    isActive: false,
    color: "",
    mode: "",
    timeout: 2000,
    text: ""
  },

  accessToken: ""
};

const state = { ...initialState };

const getters = {
  getSnackbarAlert(state) {
    return state.snackbar;
  },
  getUserDetails(state) {
    return state.user;
  },
  isLoading(state) {
    return state.loaderState;
  },
  getUserRole(state) {
    return state.user.role;
  },

  getAccessToken(state) {
    state.accessToken = localStorage.getItem("SlidesAccesstoken");
    return state.accessToken;
  }
};

const mutations = {
  toaster(state, snackbarOptions) {
    state.snackbar.isActive = true;
    state.snackbar.text = snackbarOptions.text;
    state.snackbar.color = snackbarOptions.color;
  },
  hideToaster(state, snackbarOptions) {
    state.snackbar.isActive = false;
  },
  setUser(state, user) {
    state.user = userSchema(
      user.UserId,
      user.UserName,
      user.RoleName,
      user.Area,
      user.Team,
      user.Office,
      user.ProfileUrl,
      user.Group,
      user.Email
    );
  },
  toggleLoading(state, isLoading) {
    state.loaderState = isLoading;
  },
  setProfileImage(state, profileUrl) {
    state.user.profileUrl = profileUrl;
  },

  setAccessToken(state, token) {
    localStorage.setItem("SlidesAccesstoken", token);
    state.accessToken = token;
  }
};

const actions = {
  authenticateUser(context, token) {
    setLocalStorageItem(tokensConstant.AccessToken, token.AccessToken);
    setLocalStorageItem(tokensConstant.RefreshtToken, token.RefreshToken);
    var userClaims = decodeToken(token.AccessToken);
    context.commit("setUser", userClaims);
  },

  logOffUser(context) {
    localStorage.clear();
    context.commit("setUser", userSchema());
    router.push("/login");
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
